import { render, staticRenderFns } from "./ListMagazine.vue?vue&type=template&id=1510710e&"
import script from "./ListMagazine.vue?vue&type=script&lang=js&"
export * from "./ListMagazine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports